import React from "react";
import classNames from "lib/classNames";
import Image from "next/image";
import { useRouter } from "next/router";
import Body from "components/Body";
import { ArrowRightIcon } from "@heroicons/react/outline";
import NextLink from "components/NextLink";

export default function ParagraphCard({ data, vertical = false }) {
  const router = useRouter();
  const hasImage = data.field_image || false;
  const hasLink = data.field_link || false;

  const clickHandler = (event) => {
    if (hasLink) {
      event.preventDefault();
      router.push(data.field_link.url);
    }
  };

  return (
    <div
      className={classNames(
        "flex flex-col bg-primary text-white rounded-lg overflow-hidden shadow-spead h-full",
        !vertical && "md:flex-row",
        hasLink && "cursor-pointer hover:bg-primary-dark transition-colors"
      )}
      onClick={clickHandler}
    >
      <div className="flex-1 order-1 p-8 xl:p-12">
        <div className="text-xl font-important font-medium mb-8">
          {data.field_title}
        </div>
        <div className="prose prose-white max-w-none">
          <Body value={data.field_text.processed} />
        </div>
        {hasLink && <CardLink link={data.field_link} />}
      </div>
      {hasImage && (
        <div
          className={classNames(
            "order-0 relative w-full",
            !vertical && "md:order-2 md:w-1/3"
          )}
        >
          <figure
            className={classNames(
              "aspect-w-16 aspect-h-10",
              !vertical && "md:aspect-none"
            )}
          >
            <Image
              src={data.field_image.image_style_uri.medium}
              {...data.field_image.resourceIdObjMeta}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
            />
          </figure>
        </div>
      )}
    </div>
  );
}

function CardLink({ link }) {
  const fromUri = link.uri.split(":").pop();
  return (
    <NextLink
      href={link.url !== "" ? link.url : fromUri}
      className="flex items-center mt-8 gap-4"
      passHref
    >
      <span className="block p-2 bg-white rounded-full">
        <ArrowRightIcon className="h-5 w-5 text-primary" />
      </span>
      <span className="font-important font-medium">{link.title}</span>
    </NextLink>
  );
}
